<template>
<div id="maincontent">
    <div style="visibility:hidden; opacity:0" class="dropzone"><h2 style="color:white; margin-top: 15em;">Drag your image here</h2></div>
    <div class="d-flex flex-row justify-content-between" id="main">
    <div class="d-flex flex-column justify-content-between" id="steps">
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Personal Info</p>
                <!-- <p class="bottom-text" style="color: transparent;">Personal Info</p> -->
            </div>
            <div class="col steps-step circle-top">
                <div class="circle done"><div class="checkmark"></div></div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Company</p>
                <!-- <p class="bottom-text">Brief company info</p> -->
            </div>
            <div class="col steps-step grey-circle">
                <div class="circle active">2</div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Your message</p>
                <!-- <p class="bottom-text">Company Description</p> -->
            </div>
            <div class="col steps-step grey-circle">
                    <div class="circle circle-last">3</div>
            </div>
        </div>
    </div>
        <div id="regform">
            <form class="text-left d-flex flex-column justify-content-between">
                <p id="titlename">Company</p>
                <div class="group">
                    <input class="input" v-model="companyName" @input="companyNamechange" :class="{used: companyNameused}"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Name</label>
                </div>
                <div class="group " ref="Slogan">
                    <input class="input " v-model="briefdescription" @input="briefdescriptionchange" :class="{used: briefdescriptionused}" maxlength="64" />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Brief description</label>
                    <p class="limit" ref="Limit">64</p>
                </div>
                <div class="group">
                    <textarea class="input" v-model="description" @input="descriptionchange" :class="{used: descriptionused}" rows="5"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Company description</label>
                </div>
                <div class="group">
                    <label id="filelabel" ref="Labelref">Company Logo</label>
                    <img ref="Logoref" class="loaded-image" hidden="true"/>
                    <label class="fileContainer">
                        Choose
                        <input type="file" @change="iconload" accept="image/*" ref="Logo" />
                    </label>
                </div>
            </form>
            <p v-if="feedback" class="feedback">{{feedback}}</p>
            <div class="form-inline buttons justify-content-center">
                <a href="#" class="button" @click.prevent="prev">Prev</a>
                <span>|</span>
                <a href="#" class="button" @click.prevent="next">Next</a>
            </div>
        </div>
    </div>
    
    </div>
</template>
<script>
export default {
    name: 'Step2',
    props:['uid', 'previousfirstname', 'previouslastname', 'previousemail', 'previouscity', 'previousstate', 'previousrole', 'previousspiritanimal', 'previousicon', 'previouscompanyName', 'previousbriefdescription', 'previouslogo', 'previousdescription', 'previousmessage'],
    data(){
        return{
            feedback: null,
            companyName: null, 
            briefdescription: null,
            description: null,
            logo: null,
            companyNameused: false,
            briefdescriptionused: false,
            descriptionused: false
        }
    },
    methods:{
        iconload(e){
            this.setLogo(this.$refs.Logo.files[0])
        },
        setLogo(logo){
            this.logo = logo
            var readerLogo  = new FileReader()
            var thisobj = this
            readerLogo.onloadend = function () {
                let res = readerLogo.result
                callbackLogo(res)
            }
            if (this.logo) {
                readerLogo.readAsDataURL(this.logo)
            } else {
                thisobj.$refs.Logoref.src = ""
            } 
            function callbackLogo(data){
                if(thisobj.$refs.Labelref)
                    thisobj.$refs.Labelref.hidden = true
                if(thisobj.$refs.Logoref){
                    thisobj.$refs.Logoref.hidden = false
                    thisobj.$refs.Logoref.src = data
                }
            }
        },
        prev(){
            this.$router.push({name: 'Step1', params: {uid: this.uid, previousfirstname: this.previousfirstname, previouslastname: this.previouslastname, previousemail: this.previousemail, previouscity: this.previouscity, previousstate: this.previousstate, previousrole: this.previousrole,
            previousspiritanimal: this.previousspiritanimal, previousicon: this.previousicon, previouscompanyName: this.companyName, previousbriefdescription: this.briefdescription, previouslogo: this.logo, previousdescription: this.description, previousmessage: this.previousmessage}} )
        },
        next(){
            if(this.briefdescription && this.companyName && this.logo){
                this.$router.push({name: 'Step3', params: {uid: this.uid, previousfirstname: this.previousfirstname, previouslastname: this.previouslastname, previousemail: this.previousemail, previouscity: this.previouscity, previousstate: this.previousstate, previousrole: this.previousrole,
                previousspiritanimal: this.previousspiritanimal, previousicon: this.previousicon, previouscompanyName: this.companyName, previousbriefdescription: this.briefdescription, previouslogo: this.logo, previousdescription: this.description, previousmessage: this.previousmessage}} )
            }
            else{
                this.feedback = "You must enter all fields"
            }
        },
        companyNamechange(e){
            this.companyName = e.target.value
            if(this.companyName == null || this.companyName == ''){this.companyNameused = false}
            else {this.companyNameused = true}
        },
        briefdescriptionchange(e){
            this.briefdescription = e.target.value
            if(this.briefdescription.length <= 64){
                this.$refs.Limit.textContent = 64 - this.briefdescription.length
            }
            if(this.briefdescription == null || this.briefdescription == ''){this.briefdescriptionused = false}
            else {this.briefdescriptionused = true}
        },
        descriptionchange(e){
            this.description = e.target.value
            if(this.description == null || this.description == ''){this.descriptionused = false}
            else {this.descriptionused = true}
        }
    },
    beforeCreate: function() {
            document.body.className = 'registration';
    },
    created(){
        if(this.previouscompanyName != null && this.previouscompanyName != ''){
            this.companyName = this.previouscompanyName
            this.companyNameused = true
        }
        if(this.previousbriefdescription != null && this.previousbriefdescription != ''){
            this.briefdescription = this.previousbriefdescription
            this.briefdescriptionused = true
        }
        if(this.previousdescription != null && this.previousdescription != ''){
            this.description = this.previousdescription
            this.descriptionused = true
        }
        if(this.previouslogo != null && this.previouslogo != ''){
            this.logo = this.previouslogo
        }
        if(!this.uid){
            this.$router.push({name: 'Step1'})
        }
        var lastTarget = null;
        window.addEventListener("dragenter", function(e)
        {
            lastTarget = e.target
            document.querySelector(".dropzone").style.visibility = ""
            document.querySelector(".dropzone").style.opacity = 1
        })

        window.addEventListener("dragleave", function(e)
        {
            if(e.target === lastTarget || e.target === document)
            {
                document.querySelector(".dropzone").style.visibility = "hidden"
                document.querySelector(".dropzone").style.opacity = 0
            }
        })
        window.addEventListener("dragover", function(e){
            e.preventDefault()
        })
        var thisRef = this
        window.addEventListener("drop",function(e){
            e.preventDefault()
            e.stopPropagation()
            
            document.querySelector(".dropzone").style.visibility = "hidden"
            document.querySelector(".dropzone").style.opacity = 0

            const files = e.dataTransfer.files
            if(files[0].type.split('/')[0]=='image'){
                thisRef.setLogo(files[0])
            }
            else
                alert("You can upload only image")
        })
    },
    mounted(){
        if(this.logo){
            this.setLogo(this.logo)
        }
        if(this.briefdescription){
            if(this.briefdescription.length <= 64){
                    this.$refs.Limit.textContent = 64 - this.briefdescription.length
                }
        }
    }
}
</script>
<style scoped>
div.dropzone
{
    /* positions to point 0,0 - required for z-index */
    position: fixed; top: 0; left: 0; 
    /* above all elements, even if z-index is used elsewhere
       it can be lowered as needed, but this value surpasses
       all elements when used on YouTube for example. */
    z-index: 9999999999;               
    /* takes up 100% of page */
    width: 100%; height: 100%;         
    /* dim the page with 50% black background when visible */
    background-color: rgba(0,0,0,0.5);
    /* a nice fade effect, visibility toggles after 175ms, opacity will animate for 175ms. note display:none cannot be animated.  */
    transition: visibility 175ms, opacity 175ms;
}
.limit{
    position: absolute;
	top: 5px;
	right: 5px;

    padding: 2px 4px 1px 4px;
	
    font-size: 8px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    border: 1px solid #8954BA;
    border-radius: 1em;
	pointer-events: none;
    margin-bottom: 1em;
}
.feedback{
    color: red;
}
#maincontent{
    height: 70%;
}
#main{
    /* height: 60%; */
    width: 90%;
    /* margin-bottom: 2em; */
}
#fileinput{
  margin-top: 2.5em;
}
#regform{
    margin-left: auto;
    margin-right: auto;
}
#titlename{
    color: #8954BA;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
}
#steps{
    width: 19em;
    padding-top: 3em;
    padding-bottom: 3em;
    height: 20em;
}
#steps p{
    margin: 0;
    display: inline-block;
    margin-bottom: 2em;
}
.step-title p{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.step-title .bottom-text{
    color: #A1A1A1;
}
.button{
    background-color: #5D38DB;
    border-color: white;
    padding: 1.2em 3em;
    border-radius: 7px;
    font-family: GothamBook;
    font-size: 13px;
    color: white !important;
    cursor: pointer !important;
    margin-bottom: 0.5em;
    margin-right: 1em;
    margin-left: 1em;
    font-weight: bold;
}
.form-inline span{
    color: #C9C9C9;
    font-size: 1.7em;
}
.circle{
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2em;
  border-radius: 1em;
  background: white;
  border: 1px solid #5D38DB;
  color: black !important;
  margin: 0 1em;
  display: inline-block;
  color: white;
  position: relative;
}
.circle::before{
    margin-left: 3px;
    top: 2em;
    bottom: 0;
    position: absolute;
    content: "";
    width: 2px;
    height: 300%;
    background-color: #D9DCE6;
}
.circle-last::before{
    height: 200%;
}
.steps-step.circle-top::before{
    margin-left: 1.9em;
    bottom: 3em;
    position: absolute;
    content: "";
    width: 2px;
    height: 100%;
    background-color: #D9DCE6;
}
.steps-step.grey-circle::before{
    margin-left: 1.7em;
    bottom: 4.7em;
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 1em;
    background-color: #D9DCE6;
}
.steps-step .active{
      background: #5D38DB;
      color: white !important;
}
.steps-step .done{
   border: 1px solid #78CA3C ;
}
.steps-step .done::before{
    margin-left: 4px;
}
.group{ 
  position:relative; 
  margin-bottom:45px; 
}
.input{
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width:310px;
  border:none;
  border-bottom:1px solid #D0D6E6;
}
.input:focus{ outline:none; }

.label{
  color:#686868; 
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  font-family: GothamBook;
  font-size: 14px;
}

/* .limit:after{
    position: absolute;
	top: 18px;
	right: 5px;

    padding: 2px 4px 1px 4px;
	content: '32';
    font-size: 8px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    border: 1px solid #8954BA;
    border-radius: 1em;
	pointer-events: none;
} */

.used ~.label     {
  top:-20px;
  font-size:14px;
  transition: 0.2s ease all;
  color:#686868;
}
.used{
    color: #8954BA;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.bar  { position:relative; display:block; width:310px; }
.bar:before, .bar:after   {
  content:'';
  height:2px; 
  width:0;
  bottom:1px; 
  position:absolute;
  background:#8954BA; 
  transition:0.2s ease all; 
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%; 
}

.input:focus ~ .bar:before, .input:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position:absolute;
  height:60%; 
  width:100px; 
  top:25%; 
  left:0;
  pointer-events:none;
  opacity:0.5;
}

input:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}

@keyframes inputHighlighter {
  from  { background:#5264AE; }
  to    { width:0; background:transparent; }
}

.fileContainer {
    overflow: hidden;
    position: relative;
}

.fileContainer [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}

.fileContainer {
    background: white;
    border: 1px solid #C1C1C1;
    border-radius: 2px;
    float: right;
    padding: 0.1em 1em 0.1em 1em;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}

.fileContainer [type=file] {
    cursor: pointer;
}
#filelabel{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.loaded-image{
    height: 5em;
}
.buttons{
    margin-top: 2em;
}
@media (max-width: 1124px) {
    #steps{
        display: none !important;
    }
}


.checkmark{
  display:inline-block;
  }
  .checkmark::after{
    content: '';
    display: block;
    width: 9px;
    height: 18px;
    border: solid #78CA3C;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-left: 0.1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/Step2.vue